var _circle, _circle2, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup10000117041(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.56,
    cy: 29.2,
    r: 28.8,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_627_7204",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 58
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.56,
    cy: 29.2,
    r: 28.8,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_627_7204)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.3456,
    y: -22.64,
    width: 65.3752,
    height: 80.533,
    transform: "rotate(45 30.3456 -22.64)",
    fill: "url(#paint0_linear_627_7204)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9456,
    y: 6.16003,
    width: 65.3752,
    height: 80.533,
    transform: "rotate(45 51.9456 6.16003)",
    fill: "#FF6634"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.051 43.4551V15.5995C21.051 15.1788 21.3965 14.8 21.8716 14.8H31.934C37.03 14.8 41.2191 18.2084 41.2191 22.6265C41.2191 25.8665 38.2393 28.2229 36.2095 29.2749C38.4984 30.2006 41.9965 32.2624 41.9965 36.1336C41.9965 40.8463 37.721 44.2546 32.5818 44.2546H21.8716C21.3965 44.2546 21.051 43.8759 21.051 43.4551ZM27.7881 26.7502H31.1567C32.7978 26.7502 34.1797 25.4037 34.1797 23.7206C34.1797 22.0375 32.7978 20.8593 31.1567 20.8593H27.7881V26.7502ZM27.7881 38.2375H31.7181C33.4024 38.2375 34.8275 36.891 34.8275 35.1658C34.8275 33.4826 32.9705 32.2203 31.2862 32.2203H27.7881V38.2375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0125 24.2319C11.8874 24.1137 11.8499 24.0664 11.9499 23.901L12.5378 22.9201C12.6378 22.7664 12.8755 22.7901 12.963 22.8492C13.013 22.8728 13.9136 23.4992 14.739 23.4992C15.2393 23.4992 15.602 23.2037 15.602 22.7901C15.602 22.2937 15.1643 21.9155 14.3138 21.5964C13.2382 21.1946 11.8874 20.4028 11.8874 18.9846C11.8874 17.8146 12.8504 16.6328 14.7766 16.6328C16.0773 16.6328 17.0779 17.2592 17.4531 17.5192C17.6032 17.6019 17.5782 17.8146 17.5282 17.8974L16.8903 18.8074C16.8027 18.9374 16.5776 19.0437 16.465 18.961C16.3525 18.9019 15.4394 18.2519 14.6765 18.2519C14.2262 18.2519 13.8885 18.5355 13.8885 18.8546C13.8885 19.2919 14.2638 19.6228 15.2518 20.001C16.2274 20.3674 17.7783 21.0883 17.7783 22.6955C17.7783 23.9128 16.6652 25.1419 14.8266 25.1419C13.2007 25.1419 12.3001 24.5037 12.0125 24.2319Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627_7204",
    x1: 63.0332,
    y1: -22.64,
    x2: 63.0332,
    y2: 57.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC20D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6E3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10000117041);
export default __webpack_public_path__ + "static/media/Group 1000011704-1.8ae9ef1ef73d4ddf1a8b8b0a150960ce.svg";
export { ForwardRef as ReactComponent };